var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAccept || _vm.hasPaid
    ? _c("HKLFragment", [
        _c(
          "div",
          { staticClass: "row inline-flex", class: { edit: _vm.isEdit } },
          [
            _c(
              "div",
              { staticClass: "small-6" },
              [
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("project.submission.paymentStatus"),
                    value: _vm.paidStatusText,
                    readonly: true,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "small-6" },
              [
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("project.submission.paymentDate"),
                    value: _vm.paidDateText,
                    readonly: true,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }